// This file is auto-generated by @hey-api/openapi-ts

import type { Options as ClientOptions, TDataShape, Client } from '@hey-api/client-axios';
import type { MunicipalitiesData, MunicipalitiesResponse, MunicipalitiesError, QueryData, QueryResponse, QueryError, SearchByFarIdData, SearchByFarIdResponse, SearchByFarIdError, SearchData, SearchResponse, SearchError } from './types.gen';
import { client as _heyApiClient } from './client.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = ClientOptions<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Returns all available municipalities with name and code
 */
export const municipalities = <ThrowOnError extends boolean = false>(options?: Options<MunicipalitiesData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<MunicipalitiesResponse, MunicipalitiesError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/address-search/v1/municipalities',
        ...options
    });
};

/**
 * Get addresses using elastic search query
 */
export const query = <ThrowOnError extends boolean = false>(options: Options<QueryData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<QueryResponse, QueryError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/address-search/v1/query',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Get address by address id
 */
export const searchByFarId = <ThrowOnError extends boolean = false>(options: Options<SearchByFarIdData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<SearchByFarIdResponse, SearchByFarIdError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/address-search/v1/search/addressid/{id}',
        ...options
    });
};

/**
 * Get addresses by simple searchstring. Structure: Streetname houseNumber+houseLetter apartmentNumber postalPlace. Minimum length on searchString is 2. Examples: Telenorsgate 1A Fornebu / Telenorsgate 1A H0101 Fornebu.
 */
export const search = <ThrowOnError extends boolean = false>(options: Options<SearchData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<SearchResponse, SearchError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/address-search/v1/search/{searchString}',
        ...options
    });
};